import { createRoot } from "react-dom/client";
import type { Container } from "react-dom/client";
import { notifyError } from "common/utils/app-monitoring/notify";

type ErrorKind = "caught" | "uncaught" | "recoverable";

const reportError =
  (kind: ErrorKind, appName: string) =>
  (error: unknown, errorInfo: { componentStack?: string | undefined }) => {
    console.error(`[${appName}] [React ${kind} error]`, error, errorInfo.componentStack);
    const err = error instanceof Error ? error : new Error(String(error));
    notifyError(err, {
      context: {
        reactErrorKind: kind,
        appName,
        componentStack: errorInfo.componentStack ?? null
      }
    });
  };

export function createReactRoot(container: Container, appName: string) {
  return createRoot(container, {
    onCaughtError: reportError("caught", appName),
    onUncaughtError: reportError("uncaught", appName),
    onRecoverableError: reportError("recoverable", appName)
  });
}
